import {writable} from 'svelte/store';

const createStore = () => {
  const {subscribe, set, update} = writable([]);

  const reset = () => {
    set([]);
  };

  const toggle = (stat, score) => {
    update((oldFilters) => {
      const newFilters = [];
      let wasSelected;

      oldFilters.forEach((oldFilter) => {
        if (oldFilter.stat.name === stat.name && oldFilter.score === score) {
          wasSelected = true;
        }

        if (oldFilter.stat.name !== stat.name) {
          newFilters.push(oldFilter);
        }
      });

      if (!wasSelected) {
        newFilters.push({stat: stat, score: score});
      }

      return newFilters;
    });
  };

  return {
    subscribe,
    set,
    toggle,
    reset
  };
};

export const scoresStore = createStore();
